const ITEMS_PER_PAGE = {
  '24': 24,
} as const;

export type ItemsPerPage = typeof ITEMS_PER_PAGE[keyof typeof ITEMS_PER_PAGE];

export default ITEMS_PER_PAGE;
